import React, { Component } from 'react';
import { Modal, Form, Input, Button, Upload, Icon, message } from 'antd';

import { FormContainer } from './style';
import { hasErrors } from '../../common/utils';

const { TextArea } = Input;

const getBase64 = (img, callback) => {
	const reader = new FileReader();
	reader.addEventListener('load', () => callback(reader.result));
	reader.readAsDataURL(img);
};

class ModalForm extends Component {
	state = {
		loading: false,
		imageUrl: undefined,
		banner: undefined
	};

	componentDidMount() {
		this.initialize();
	}

	initialize = () => {
		const { data, form } = this.props;
		const { setFieldsValue } = form;
		const keys = Object.keys(data);
		const state = {};
		if (keys.length !== 0) {
			keys.forEach((key) => {
				state[key] = data[key];
			});
			setFieldsValue(state);
		}
	};

	handleChange = (info) => {
		if (info.file.status === 'uploading') {
			getBase64(info.file.originFileObj, (imageUrl) =>
				this.setState({
					imageUrl,
					loading: false,
					banner: info.file.originFileObj
				})
			);
		}
	};

	beforeUpload = (file) => {
		const isJpgOrPng =
			file.type === 'image/jpeg' || file.type === 'image/png';
		if (!isJpgOrPng) {
			message.error('You can only upload JPG/PNG file!');
		}
		const isLt2M = file.size / 1024 / 1024 < 2;
		if (!isLt2M) {
			message.error('Image must smaller than 2MB!');
		}
		return isJpgOrPng && isLt2M;
	};

	handleSubmitInfo = (e) => {
		e.preventDefault();
		const { getFieldValue } = this.props.form;
		const body = {
			title: getFieldValue('title'),
			description: getFieldValue('description')
		};
		this.props.onSubmit(body);
	};

	handleSubmitBanner = (e) => {
		e.preventDefault();
		const { banner } = this.state;
		if (banner) {
			e.preventDefault();
			const body = {
				banner
			};
			this.setState({ isLoading: true });
			this.props.onSubmit(body);
		} else {
			message.warn('Upload image.');
		}
	};

	handleSubmitPitch = (e) => {
		e.preventDefault();
		const { getFieldValue } = this.props.form;
		const body = {
			usp: getFieldValue('usp'),
			risk: getFieldValue('risk'),
			operator: getFieldValue('operator'),
			timeline: getFieldValue('timeline')
		};
		this.props.onSubmit(body);
	};

	renderForm = () => {
		const { type, form } = this.props;
		const { imageUrl } = this.state;
		const { getFieldDecorator, getFieldsError } = form;
		switch (type) {
			case 'info':
				return (
					<Form onSubmit={this.handleSubmitInfo}>
						<Form.Item>
							<h4>Title</h4>
							{getFieldDecorator('title')(<Input />)}
						</Form.Item>
						<Form.Item>
							<h4>Description</h4>
							{getFieldDecorator('description', {
								rules: [
									{
										len: 'len',

										max: 200,
										message: 'Description is 200 character'
									}
								]
							})(<TextArea />)}
						</Form.Item>
						<Button
							block
							type="primary"
							htmlType="submit"
							disabled={hasErrors(getFieldsError())}
						>
							Save
						</Button>
					</Form>
				);
			case 'banner':
				return (
					<Form onSubmit={this.handleSubmitBanner}>
						<Form.Item style={{ textAlign: 'center' }}>
							<Upload
								name="avatar"
								listType="picture-card"
								className="avatar-uploader"
								showUploadList={false}
								beforeUpload={this.beforeUpload}
								onChange={this.handleChange}
							>
								{imageUrl ? (
									<img
										src={imageUrl}
										alt="avatar"
										style={{ width: '100%' }}
									/>
								) : (
									<div>
										<Icon
											type={this.state.loading ? 'loading' : 'plus'}
										/>
										<div className="ant-upload-text">
											Upload Banner
										</div>
									</div>
								)}
							</Upload>
							<p>
								500*270 image pixel is recommended, size should be below
								2MB.
							</p>
						</Form.Item>
						<Button
							block
							type="primary"
							htmlType="submit"
							loading={this.state.isLoading}
						>
							Save
						</Button>
					</Form>
				);
			case 'pitch':
				return (
					<Form onSubmit={this.handleSubmitPitch}>
						<Form.Item>
							<h4>Unique Points</h4>
							<p>
								Features, currencies and other unique project offerings.
							</p>
							{getFieldDecorator('usp')(<TextArea />)}
						</Form.Item>
						<Form.Item>
							<h4>Risk & Challenges</h4>
							<p>
								Explain the risks and challenges with your exchange
								operations. Transparency is key!
							</p>
							{getFieldDecorator('risk')(<TextArea />)}
						</Form.Item>
						<Form.Item>
							<h4>About Operator</h4>
							<p>
								Who is behind the project and what credentials do they
								have relevant to the project
							</p>
							{getFieldDecorator('operator')(<TextArea />)}
						</Form.Item>
						<Form.Item>
							<h4>Timeline</h4>
							<p>
								Projected estimated timeline for the project. Milestones
								before the launch and other important dates.
							</p>
							{getFieldDecorator('timeline')(<TextArea />)}
						</Form.Item>
						<Button block type="primary" htmlType="submit">
							Save
						</Button>
					</Form>
				);
			default:
				return null;
		}
	};

	render() {
		const { visible, onCancel, type } = this.props;
		const title =
			type === 'info'
				? 'Edit Exchange Info'
				: type === 'banner'
				? 'Banner'
				: 'Edit Pitch';
		return (
			<Modal
				visible={visible}
				title={title}
				footer={null}
				onCancel={onCancel}
			>
				<FormContainer>{this.renderForm()}</FormContainer>
			</Modal>
		);
	}
}

export default Form.create({ name: 'Project Form' })(ModalForm);
